import { configPublic } from '@src/config.public'
import { getUnlocalizedPath, isAppPath } from '@src/i18n/locale.util'
import { PROGRAM_QUIZ_PATH } from '@src/utils/constants.util'

export type AnalyticsTarget = 'web' | 'digital'

/** Unlocalized paths outside /app that still report to the digital Amplitude project. */
const DIGITAL_PATHS = ['/forgot-password', '/create-password', PROGRAM_QUIZ_PATH]

export function isDigitalPath(pathname: string): boolean {
  if (isAppPath(pathname)) return true
  const unlocalized = getUnlocalizedPath(pathname)
  return DIGITAL_PATHS.some((path) => unlocalized === path || unlocalized.startsWith(`${path}/`))
}

export function getAnalyticsTarget(pathname: string): AnalyticsTarget {
  const { onesiteEnabled } = configPublic.featureFlags
  const { apiKeyDigital } = configPublic.amplitude
  if (!onesiteEnabled || !apiKeyDigital) return 'web'
  return isDigitalPath(pathname) ? 'digital' : 'web'
}
